import {
    NT_SEARCH_MARKETING_PRODUCT_KEY,
    NT_DISPLAY_MARKETING_PRODUCT_KEY,
    NT_AFFILIATE_MARKETING_PRODUCT_KEY,
    NT_ESSENTIAL_PRODUCT_KEY,
    NT_ADVANCED_PRODUCT_KEY,
} from "app/constants/ntProductKeys";
import type { NavigationTile } from "app/pages/digital-marketing/home-pages/constants";

export const navigationTiles: NavigationTile[] = [
    {
        id: "websiteAnalysis",
        title: "digitalmarketing.homepage.website.analysis.title",
        subTitle: "digitalmarketing.homepage.website.analysis.subtitle",
        redirectPageText: "digitalmarketing.homepage.website.analysis.redirect.subtitle",
        iconName: "website-analysis",
        navigationState: "digitalsuite_websiteanalysis_home",
        useRedirect: false,
    },
    {
        id: "organicCompetitors",
        title: "digitalmarketing.homepage.organic.competitors.title",
        subTitle: "digitalmarketing.homepage.organic.competitors.subtitle",
        redirectPageText: "digitalmarketing.homepage.organic.competitors.redirect.subtitle",
        navigationState: "organicsearch_websites-competitorsKeywords",
        iconName: "megaphone",
        useRedirect: true,
        userTypes: [
            NT_DISPLAY_MARKETING_PRODUCT_KEY,
            NT_SEARCH_MARKETING_PRODUCT_KEY,
            NT_ESSENTIAL_PRODUCT_KEY,
            NT_ADVANCED_PRODUCT_KEY,
        ],
    },
    {
        id: "paidCompetitors",
        title: "digitalmarketing.homepage.paid.competitors.title",
        subTitle: "digitalmarketing.homepage.paid.competitors.subtitle",
        redirectPageText: "digitalmarketing.homepage.paid.competitors.redirect.subtitle",
        navigationState: "organicsearch_websites-competitorsKeywords",
        iconName: "paid-competitors",
        useRedirect: true,
        userTypes: [
            NT_AFFILIATE_MARKETING_PRODUCT_KEY,
            NT_DISPLAY_MARKETING_PRODUCT_KEY,
            NT_ESSENTIAL_PRODUCT_KEY,
            NT_ADVANCED_PRODUCT_KEY,
        ],
    },
    {
        id: "keywordGenerator",
        title: "digitalmarketing.homepage.keyword.generator.title",
        subTitle: "digitalmarketing.homepage.keyword.generator.subtitle",
        iconName: "page-with-coffee",
        navigationState: "digitalsuite_findkeywords_keywordGeneratorTool",
        userTypes: [NT_SEARCH_MARKETING_PRODUCT_KEY, NT_ESSENTIAL_PRODUCT_KEY, NT_ADVANCED_PRODUCT_KEY],
    },
    {
        id: "keywordAnalysis",
        title: "digitalmarketing.homepage.keyword.analysis.title",
        subTitle: "digitalmarketing.homepage.keyword.analysis.subtitle",
        iconName: "affiliates-keyword",
        navigationState: "organicsearch_keywordanalysis_home",
        userTypes: [NT_SEARCH_MARKETING_PRODUCT_KEY, NT_ESSENTIAL_PRODUCT_KEY, NT_ADVANCED_PRODUCT_KEY],
    },
];

export const basicReportsForAfterTrial: NavigationTile[] = [
    {
        id: "websiteAnalysis",
        title: "digitalmarketing.homepage.website.analysis.title",
        subTitle: "digitalmarketing.homepage.website.analysis.subtitle",
        iconName: "website-analysis",
        navigationState: "digitalsuite_websiteanalysis_home",
        useRedirect: false,
    },
    {
        id: "webIndustryAnalysis",
        title: "digitalsuite.homepage.web.industry.analysis.title",
        subTitle: "digitalsuite.homepage.web.industry.analysis.subtitle",
        iconName: "search-interest-analysis",
        navigationState: "digitalsuite_webmarketanalysis_home",
    },
    {
        id: "websiteAudienceGeography",
        title: "digitalsuite.homepage.website.audience.geography.title",
        subTitle: "digitalsuite.homepage.website.audience.geography.subtitle",
        redirectPageText: "digitalsuite.homepage.website.audience.geography.redirect.subtitle",
        iconName: "spaceship",
        navigationState: "digitalsuite_website_geography",
        useRedirect: true,
    },
    {
        id: "appAnalysis",
        title: "digitalsuite.homepage.app.analysis.title",
        subTitle: "digitalsuite.homepage.app.analysis.subtitle",
        iconName: "ad-tech",
        navigationState: "digitalsuite_appanalysis_home",
    },
];

export const basicReportsForAEOSolution: NavigationTile[] = [
    {
        id: "websiteAnalysis",
        title: "digitalmarketing.homepage.website.analysis.title",
        subTitle: "digitalmarketing.homepage.website.analysis.subtitle",
        iconName: "website-analysis",
        navigationState: "digitalsuite_websiteanalysis_home",
        useRedirect: false,
    },
    {
        id: "webIndustryAnalysis",
        title: "digitalsuite.homepage.web.industry.analysis.title",
        subTitle: "digitalsuite.homepage.web.industry.analysis.subtitle",
        iconName: "search-interest-analysis",
        navigationState: "digitalsuite_webmarketanalysis_home",
    },
];
